import { render, staticRenderFns } from "./ActionButtonsSection.vue?vue&type=template&id=2989c56a&scoped=true"
import script from "./ActionButtonsSection.vue?vue&type=script&lang=ts"
export * from "./ActionButtonsSection.vue?vue&type=script&lang=ts"
import style0 from "./ActionButtonsSection.vue?vue&type=style&index=0&id=2989c56a&prod&lang=scss&scoped=true"
import style1 from "./ActionButtonsSection.vue?vue&type=style&index=1&id=2989c56a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2989c56a",
  null
  
)

export default component.exports